import { useTranslation } from 'react-i18next';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';
import BoldLabel from '../components/BoldLabel';

const RULES = ['austria', 'czechia', 'slovakia', 'hungary', 'slovenia', 'romania', 'bulgaria'];

export default function BlogStartDatePage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-bg">
        <div className="mx-auto max-w-3xl px-5 py-14">
          <span className="inline-flex rounded-full bg-primary-soft px-3 py-1 text-[12px] font-medium text-primary">{t('blog.post9.category')}</span>
          <h1 className="mt-3 text-[26px] font-bold tracking-tight">{t('blog.post9.title')}</h1>
          <p className="mt-2 text-[14px] text-muted">{t('blog.post9.readTime')}</p>
          <div className="mt-8 space-y-5 text-[15px] leading-relaxed text-ink-soft">
            <p>{t('blog.post9.body.p1')}</p>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post9.body.h1')}</h3>
            <p>{t('blog.post9.body.p2')}</p>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post9.body.h2')}</h3>
            <p>{t('blog.post9.body.p3')}</p>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post9.body.h3')}</h3>
            <ul className="list-disc pl-5 space-y-2">
              {RULES.map((c) => (
                <li key={c}><BoldLabel text={t(`blog.post9.body.rule.${c}`)} /></li>
              ))}
            </ul>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post9.body.h4')}</h3>
            <p>{t('blog.post9.body.p4')}</p>

            <h3 className="text-[18px] font-semibold text-ink mt-6">{t('blog.post9.body.h5')}</h3>
            <p>{t('blog.post9.body.p5')}</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
